export default "__VITE_ASSET__c6m6zwO4__"